(() => {
  if (customElements.get('lk-cart-price')) return;
  class LKCartPrice extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.root = this.closest('.lk-product-page');
      this.form = document.getElementById(this.dataset.form);
      this.source = this.form?.querySelector('[name="add"]');
      if (!this.root || !this.source) return;
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-cart-price-variants]').textContent);
      this.button = this.querySelector('button');
      this.amount = this.querySelector('[data-cart-price-amount]');
      this.note = this.querySelector('[data-cart-price-note]');
      this.subtotal = Number(this.dataset.cartSubtotal);
      this.format = new Intl.NumberFormat(this.dataset.lang, { style: 'currency', currency: this.dataset.currency });
      this.variant = this.variants.find(v => String(v.id) === this.idValue());
      const options = { signal: this.abort.signal };
      this.root.addEventListener('input', () => this.update(), options);
      this.root.addEventListener('change', () => {
        this.variant = this.variants.find(v => String(v.id) === this.idValue()) || this.variant;
        this.update();
      }, options);
      document.addEventListener(`variant:change:${this.root.dataset.sectionId}:${this.root.dataset.productId}`, ({ detail }) => {
        this.variant = detail.variant;
        this.update();
      }, options);
      this.button.addEventListener('click', () => {
        this.update();
        if (this.button.disabled) return;
        this.source.click();
        this.update();
      }, options);
      this.observer = new MutationObserver(() => {
        const busy = this.source.getAttribute('aria-busy') === 'true' || this.source.classList.contains('btn--loading');
        if (this.wasBusy && !busy) this.refreshCart();
        this.wasBusy = busy;
        this.update();
      });
      this.observer.observe(this.source, { attributes: true, attributeFilter: ['disabled', 'aria-busy', 'class'] });
      for (const event of ['ajaxProduct:added', 'cart:updated', 'cart:refresh']) document.addEventListener(event, () => this.refreshCart(), options);
      this.update();
    }
    idValue() { return this.form.querySelector('[name="id"]')?.value; }
    update() {
      const quantityInput = this.root.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput?.value ?? 1);
      const valid = Number.isInteger(quantity) && quantity > 0 && (!quantityInput || quantityInput.validity.valid);
      const line = Math.round(Number(this.variant?.price || 0) * quantity);
      const eligible = valid && this.subtotal + line >= 10000;
      const total = eligible ? line - Math.round(line * 5 / 100) : line;
      const busy = this.source.getAttribute('aria-busy') === 'true' || this.source.classList.contains('btn--loading');
      this.button.disabled = this.source.disabled || busy || !valid || !this.variant;
      this.button.setAttribute('aria-busy', String(busy));
      this.amount.textContent = valid && this.variant ? this.format.format(total / 100) : '—';
      this.note.textContent = eligible ? this.dataset.discountNote : this.dataset.thresholdNote;
    }
    async refreshCart() {
      if (this.refreshPending) return;
      this.refreshPending = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, signal: this.abort.signal });
        if (response.ok) { this.subtotal = (await response.json()).original_total_price; this.update(); }
      } catch (_) {} finally { this.refreshPending = false; }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready = false; }
  }
  customElements.define('lk-cart-price', LKCartPrice);
})();
